import Modal from './Modal';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({ open, onClose, onConfirm, title = 'Confirm Delete', message, loading }) {
  return (
    <Modal open={open} onClose={onClose} title="">
      <div className="modal-body" style={{ textAlign: 'center', padding: '32px 24px' }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: 'rgba(244,63,94,.12)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <AlertTriangle size={26} color="var(--danger)" />
        </div>
        <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', marginBottom: 8 }}>{title}</h3>
        <p style={{ color: 'var(--text-muted)', fontSize: '.875rem' }}>{message || 'This action cannot be undone.'}</p>
      </div>
      <div className="modal-footer" style={{ justifyContent: 'center', gap: 12 }}>
        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        <button className="btn btn-danger" onClick={onConfirm} disabled={loading}>
          {loading ? <span className="spinner" /> : 'Delete'}
        </button>
      </div>
    </Modal>
  );
}
